import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import { useEffect, useState } from 'react';
import { createNewSurveyAnswer } from 'redux/slices/legacySurveySlice.slice';
import { useAppDispatch } from 'redux/storeHooks';
import type { SurveyProps } from './types';

const SurveyDateTime = ({
  question,
  register,
  response,
  error,
  getValues,
  unregister,
}: SurveyProps) => {
  const [inputValue, setInputValue] = useState('');
  const [savedValue, setSavedValue] = useState('');
  const dispatch = useAppDispatch();

  const registerProps = register(question.id, {
    required: question.isRequired,
    onChange: e => setInputValue(e.target.value),
  });

  useEffect(() => {
    const initialValue = getValues(question.id);

    if (initialValue) {
      setSavedValue(initialValue);
      setInputValue(initialValue);
    }

    return () => {
      unregister(question.id);
    };
  }, []);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (savedValue !== inputValue && !error) {
        submit();
      }
    }, 1500);

    return () => clearTimeout(delayDebounceFn);
  }, [inputValue]);

  const submit = () => {
    setSavedValue(inputValue);

    const saveVar = question.inputType === 'date' ? 'date' : 'dateTime';
    dispatch(
      createNewSurveyAnswer({
        body: {
          questionId: question.id,
          responseId: response.id,
          [saveVar]: inputValue,
        },
      })
    );
  };

  const helperText = () => {
    if (!error) return '';
    if (error?.type === 'required') {
      return 'A value is required';
    }
    return 'An error has occurred';
  };

  return (
    <FormControl
      fullWidth
      sx={{
        marginTop: '12px',
      }}
    >
      <TextField
        {...registerProps}
        id={`input-${question.id}`}
        label={question.inputTitle}
        error={!!error}
        helperText={helperText()}
        type={question.inputType === 'date' ? 'date' : 'datetime-local'}
        value={inputValue || ''}
        sx={{ width: 250 }}
        InputLabelProps={{
          required: question.isRequired,
          shrink: true,
        }}
      />
    </FormControl>
  );
};

export default SurveyDateTime;
